import React from "react";
import ApprovalsRejectionsContainer from "../../container/approvalRejection";

const ApprovalRejectionsScreen: React.FC<{}> = () => {
    return <ApprovalsRejectionsContainer/>;
}

export default ApprovalRejectionsScreen;